import { render, staticRenderFns } from "./PaymentAttachment.vue?vue&type=template&id=91f5f3c8"
import script from "./PaymentAttachment.vue?vue&type=script&lang=js"
export * from "./PaymentAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports